import actionTypes from '../constants/action-types';

const redirects = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SET_REDIRECTS:
      return action.payload.redirects;

    case actionTypes.UPDATE_REDIRECTS:
      return action.payload.redirects;

    default:
      return state;
  }
};

export default redirects;
